/**
 * Lower-environment testing aid: `?SAP_FETCH_FAIL=true` / `?SAP_POST_FAIL=true`
 * on an appointment page URL make the flow's SAP GETs / POSTs fail as if SAP
 * had failed in transport, to exercise the error states. Routes and client
 * components read the flags from the URL and pass them to the server actions
 * as their optional last argument; the server ignores them in production
 * (`services/sap/simulate.ts`).
 */
export interface SapFailureFlags {
  /** Fail every SAP GET (`SAP_FETCH_FAIL`). */
  fetch?: boolean;
  /** Fail every SAP POST — reschedule / cancel (`SAP_POST_FAIL`). */
  post?: boolean;
}

export const SAP_FAILURE_PARAMS = {
  fetch: "SAP_FETCH_FAIL",
  post: "SAP_POST_FAIL",
} as const;

/** The flags set on a page's search params, or undefined when neither is. */
export function readSapFailureFlags(
  searchParams: Record<string, string | undefined>,
): SapFailureFlags | undefined {
  const fetch = searchParams[SAP_FAILURE_PARAMS.fetch] === "true";
  const post = searchParams[SAP_FAILURE_PARAMS.post] === "true";
  if (!(fetch || post)) return;
  return { ...(fetch ? { fetch } : {}), ...(post ? { post } : {}) };
}
